import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'kanban';

const kanbanService = {
  getItemsByType: (type, data, allColumns) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(allColumns)}`,
      data,
    });
  },

  getStatusByType: (type) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/statusForType/${encodeURIComponent(type)}`,
    });
  },

  updateItemsByType: (type, id, statusId, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}/${encodeURIComponent(statusId)}`,
      data,
    });
  },

  updateKanbanColorLink: (subMenuUrl, lineId, color) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/color/createColor/${encodeURIComponent(subMenuUrl)}/${encodeURIComponent(lineId)}`,
      data: { color },
    });
  },

  deleteKanbanColorLink: (subMenuUrl, lineId) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(subMenuUrl)}/${encodeURIComponent(lineId)}`,
    });
  },

  getItemById: (type, id) => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
    });
  },

  createMessage: (data, type) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/${encodeURIComponent(type)}`,
      data,
    });
  },

  updateMessage: (data, type, id) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}/${encodeURIComponent(type)}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default kanbanService;
